import React from 'react'
import { Link } from 'react-router-dom';
import { Input, Button } from 'antd';
import { PLUGIN_STORE_ICON } from '../../config/media';
import { PluginWrapper } from './style';

const Home = () => {

    return (
        <PluginWrapper>
            <div className='plugin-wrapper'>
                <h1 className='plugin-header'>My plugin apps</h1>
                <div className='d-flex header-wrapper'>
                    <div>
                        <p className="header-content-wrapper">See below for all your installed plugin apps. You can get plugins</p>
                        <p className='line-height'>apps from Exchange Plugin App Store, or create your own.</p>
                    </div>
                    <Link to="/pluginstore" className='link'><Button className='header-content-btn'>EXCHANGE PLUGIN APP STORE</Button></Link>
                </div>
                <div className='d-flex title-content-wrapper'>
                    <img className='plugin-title-icon' alt='plugin-store' src={PLUGIN_STORE_ICON}></img>
                    <p className='plugin-title-content'><Link to="/pluginstore" className='link'>Visit the Exchange App Store</Link></p>
                </div>
                <div className='d-flex install-content-wrapper'>
                    <h1 className='install-header'>Installed plugin apps</h1>
                    <Input className='filter-content' placeholder="Search..."></Input>
                </div>
                <div className='horizontal-line'></div>
                <div className='d-flex justify-center'>
                    <p className="footer-title">You currently haven't got any installed plugin apps yet.</p>
                </div>
                {/* <div className='pulgin-img-wrapper'>
                    <p className='img-content d-flex'><Link to="/pluginhome" className='link'>Click here </Link>to get plugins apps.</p>
                    <img className='plugin-image' alt='plugin-home' src={PLUGIN_HOME}></img>
                </div> */}
            </div>
        </PluginWrapper>
    )
}

export default Home;